export default __webpack_public_path__ + "static/media/logo.abca5ee4.png";